(function () {
  "use strict";

  /* ---------- Meta Pixel custom events ----------
     Base code fbq() di-init di layout/theme.liquid. Event di bawah ini
     TIDAK boleh di-subscribe lagi di Shopify Custom Pixel, nanti dobel. */
  function jtTrack(name, payload) {
    try {
      if (typeof window.fbq === "function") {
        window.fbq("trackCustom", name, payload || {});
      }
    } catch (e) {}
  }

  /* ---------- TikTok Pixel events ----------
     Base code ttq di-load di sections/new-itinerary.liquid (hanya kalau
     TikTok Pixel ID di setting section diisi). */
  function jtTiktok(name, payload) {
    try {
      if (window.ttq && typeof window.ttq.track === "function") {
        window.ttq.track(name, payload || {});
      }
    } catch (e) {}
  }

  /* Kirim event dulu, baru pindah halaman. Jeda singkat supaya request ke
     facebook.com/tr dan analytics.tiktok.com sempat berangkat sebelum
     dokumen di-unload. */
  function jtTrackThenGo(name, payload, url, tiktok) {
    jtTrack(name, payload);
    if (tiktok) jtTiktok(tiktok.name, tiktok.payload);
    if (!url || url === "#") return;
    setTimeout(function () {
      window.location.href = url;
    }, 300);
  }

  function initSection(root) {
    if (!root || root.dataset.jtInit === "1") return;
    root.dataset.jtInit = "1";

    /* ---------- FAQ accordion — multi open ---------- */
    root.querySelectorAll(".jt-faq-item").forEach(function (item) {
      var btn = item.querySelector(".jt-faq-q");
      var tog = item.querySelector(".jt-faq-toggle");
      if (!btn || !tog) return;
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("jt-open");
        if (isOpen) {
          item.classList.remove("jt-open");
          tog.textContent = "+";
          btn.setAttribute("aria-expanded", "false");
        } else {
          item.classList.add("jt-open");
          tog.textContent = "−";
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });

    /* ---------- Benefit layanan: accordion (mobile) ---------- */
    root.querySelectorAll(".jt-per-acc").forEach(function (card) {
      var btn = card.querySelector(".jt-per-toggle");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var isOpen = card.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    });

    /* ---------- Scroll reveal (IntersectionObserver) ---------- */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add("jt-in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      root.querySelectorAll(".jt-reveal").forEach(function (el) {
        io.observe(el);
      });
    } else {
      root.querySelectorAll(".jt-reveal").forEach(function (el) {
        el.classList.add("jt-in");
      });
    }

    /* ---------- Reviews carousel ---------- */
    function initCarousel() {
      var track    = root.querySelector(".jt-reviews-track");
      var viewport = root.querySelector(".jt-reviews-viewport");
      var prev     = root.querySelector(".jt-review-arrow.jt-prev");
      var next     = root.querySelector(".jt-review-arrow.jt-next");
      var dotsWrap = root.querySelector(".jt-review-dots");
      if (!track || !viewport || !dotsWrap) return;

      var cards   = track.querySelectorAll(".jt-review-card");
      var total   = cards.length;
      var perView = 3;
      var index   = 0;
      var gap     = 24;

      function compute() {
        perView = window.innerWidth <= 768 ? 1 : 3;
        var vw    = viewport.clientWidth;
        var cardW = perView === 1 ? vw : (vw - gap * (perView - 1)) / perView;
        cards.forEach(function (c) {
          c.style.flex        = "0 0 " + cardW + "px";
          c.style.marginRight = perView === 1 ? "0px" : gap + "px";
        });
        var maxIndex = Math.max(0, total - perView);
        if (index > maxIndex) index = maxIndex;
        renderDots(maxIndex);
        apply();
      }

      function renderDots(maxIndex) {
        dotsWrap.innerHTML = "";
        for (var i = 0; i <= maxIndex; i++) {
          var b = document.createElement("button");
          b.className = "jt-review-dot" + (i === index ? " jt-active" : "");
          b.setAttribute("aria-label", "Slide " + (i + 1));
          (function (n) {
            b.addEventListener("click", function () { index = n; apply(); });
          })(i);
          dotsWrap.appendChild(b);
        }
      }

      function apply() {
        var vw    = viewport.clientWidth;
        var cardW = perView === 1 ? vw : (vw - gap * (perView - 1)) / perView;
        var step  = cardW + (perView === 1 ? 0 : gap);
        track.style.transform = "translateX(" + (-index * step) + "px)";
        var maxIndex = Math.max(0, total - perView);
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= maxIndex;
        dotsWrap.querySelectorAll(".jt-review-dot").forEach(function (d, i) {
          d.classList.toggle("jt-active", i === index);
        });
      }

      if (prev) {
        prev.addEventListener("click", function () {
          if (index > 0) { index--; apply(); }
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          var m = Math.max(0, total - perView);
          if (index < m) { index++; apply(); }
        });
      }

      var startX = 0, deltaX = 0, touching = false;
      viewport.addEventListener("touchstart", function (e) {
        touching = true; startX = e.touches[0].clientX; deltaX = 0;
      }, { passive: true });
      viewport.addEventListener("touchmove", function (e) {
        if (touching) deltaX = e.touches[0].clientX - startX;
      }, { passive: true });
      viewport.addEventListener("touchend", function () {
        if (!touching) return;
        touching = false;
        var m = Math.max(0, total - perView);
        if      (deltaX < -40 && index < m) { index++; apply(); }
        else if (deltaX >  40 && index > 0) { index--; apply(); }
      });

      window.addEventListener("resize", compute);
      compute();
    }

    /* ---------- Step 2 Navigation ---------- */
    function initStepNav() {
      var mainView = root.querySelector(".jt-main-view");
      var step2View = root.querySelector(".jt-step2-view");
      var backBtn = root.querySelector(".jt-back-btn");

      if (!mainView || !step2View) return;

      function showStep2(saveState) {
        mainView.style.display = "none";
        step2View.style.display = "block";
        if (saveState !== false) {
          try { sessionStorage.setItem("jt_active_step", "upgrade"); } catch (e) {}
          try { history.pushState({ step: "upgrade" }, "", window.location.href); } catch (e) {}
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      function showMain(saveState) {
        step2View.style.display = "none";
        mainView.style.display = "block";
        if (saveState !== false) {
          try { sessionStorage.removeItem("jt_active_step"); } catch (e) {}
          try { history.pushState({ step: "main" }, "", window.location.href); } catch (e) {}
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      /* Satu nama event per tombol. Custom parameter (plan, button_location)
         tidak bisa dipakai buat Custom Conversion / breakdown di Events Manager,
         jadi jumlah klik tiap tombol harus dibedakan lewat nama event-nya. */
      root.querySelectorAll(".jt-btn-hero").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          jtTrack("AmbilSemuaBonus", {
            button_text: (btn.textContent || "").trim(),
            button_location: "summary_card",
            page_path: window.location.pathname
          });
          jtTiktok("ClickButton", {
            description: "Ambil Semua Bonusnya",
            button_text: (btn.textContent || "").trim()
          });
          showStep2(true);
        });
      });

      /* Tombol CTA banner: langsung redirect ke href (WhatsApp), bukan buka step 2 */
      root.querySelectorAll(".jt-btn-cta-banner").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          var url = btn.getAttribute("href") || "";
          if (!url || url === "#") return;
          e.preventDefault();
          jtTrackThenGo("AmbilSemuaBonusBanner", {
            button_text: (btn.textContent || "").trim(),
            button_location: "cta_banner",
            page_path: window.location.pathname
          }, url, {
            name: "Contact",
            payload: {
              description: "Tanya Seputar Jasa Itinerary (WhatsApp)",
              button_text: (btn.textContent || "").trim()
            }
          });
        });
      });

      /* Tombol pilihan paket di step 2 -> add to cart permalink (mulai checkout) */
      root
        .querySelectorAll(".jt-btn-step2-upgrade, .jt-btn-step2-core")
        .forEach(function (btn) {
          btn.addEventListener("click", function (e) {
            var url = btn.getAttribute("href") || "";
            var match = url.match(/\/cart\/(\d+)/);
            var eventName = btn.classList.contains("jt-btn-step2-plus")
              ? "UpgradePremiumPlusItinerary"
              : btn.classList.contains("jt-btn-step2-upgrade")
                ? "UpgradePremiumItinerary"
                : "TetapCoreItinerary";
            var tiktokName = btn.classList.contains("jt-btn-step2-plus")
              ? "UpgradeKePremiumPlus"
              : btn.classList.contains("jt-btn-step2-upgrade")
                ? "UpgradeKePremium"
                : "TetapDenganCoreItinerary";
            var variantId = match ? match[1] : "";
            var value = Number(btn.dataset.jtValue || 0);
            e.preventDefault();
            jtTrackThenGo(
              eventName,
              {
                plan: btn.dataset.jtPlan || "",
                value: Number(btn.dataset.jtValue || 0),
                currency: "IDR",
                variant_id: variantId,
                button_text: (btn.textContent || "").trim(),
                page_path: window.location.pathname
              },
              url,
              {
                name: tiktokName,
                payload: {
                  contents: [{
                    content_id: variantId,
                    content_type: "product",
                    content_name: btn.dataset.jtPlan || ""
                  }],
                  value: value,
                  currency: "IDR"
                }
              }
            );
          });
        });

      /* Tombol CTA hero: scroll ke "Disusun Personal", bukan buka step 2 */
      root.querySelectorAll(".jt-btn-scroll-isi").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          jtTiktok("ClickButton", {
            description: "Mulai Rancang Itinerary",
            button_text: (btn.textContent || "").trim()
          });
          var target =
            root.querySelector("#disusun-personal") ||
            root.querySelector("#yang-akan-kamu-terima");
          if (!target) return; // section disembunyikan -> biarkan href default
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });

      if (backBtn) {
        backBtn.addEventListener("click", function (e) {
          e.preventDefault();
          showMain(true);
        });
      }

      window.addEventListener("popstate", function (e) {
        if (e.state && e.state.step === "upgrade") {
          showStep2(false);
        } else {
          showMain(false);
        }
      });

      try {
        if (sessionStorage.getItem("jt_active_step") === "upgrade") {
          showStep2(false);
        }
      } catch (e) {}
    }

    initStepNav();
    initCarousel();
  }

  function initAll() {
    document.querySelectorAll(".japan-trips").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (e) {
      var root = e.target.querySelector(".japan-trips");
      if (root) initSection(root);
    });
  }
})();
